import React from "react";
import { FaEnvelope, FaPhone, FaUserPlus } from "react-icons/fa";

const RecentVisitors = ({visitors, loading}) => {
    

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
        <FaUserPlus className="w-6 h-6 text-green-600 mr-2" />
        Recent Visitors
      </h3>
      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto"></div>
          <p className="text-gray-500 mt-2">Loading visitors...</p>
        </div>
      ) : visitors?.length > 0 ? (
        <div className="space-y-4">
          {visitors.map((visitor, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <FaUserPlus className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <h4 className="font-medium text-gray-800">{visitor.first_name} {visitor.last_name}</h4>
                  <div className="flex items-center space-x-4 text-sm text-gray-600">
                    {visitor.phone_number && (
                      <span className="flex items-center">
                        <FaPhone className="w-3 h-3 mr-1" />
                        {visitor.phone_number}
                      </span>
                    )}
                    {visitor.email && (
                      <span className="flex items-center">
                        <FaEnvelope className="w-3 h-3 mr-1" />
                        {visitor.email}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="text-right text-sm text-gray-500">
                <p>{visitor.registration_date}</p>
                
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <FaUserPlus className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>No recent visitors</p>
          <p className="text-sm">Visitors you register will appear here</p>
        </div>
      )}
    </div>
  );
};

export default RecentVisitors;
